export default __webpack_public_path__ + "static/media/hero.fe756fb2.png";